<template>
  <div class="custom-select">
    <select
      :value="modelValue"
      @change="$emit('update:modelValue', +$event.target.value)"
    >
      <option
        v-for="(item, index) in items"
        :key="index"
        :value="index"
      >{{ item }}</option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'CustomSelect',

  props: {
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="sass" scoped>
.custom-select
  width: 102px
  position: relative
  &::after
    content: ''
    border-left: 5px solid transparent
    border-right: 5px solid transparent
    border-top: 5px solid #fff
    width: 0
    height: 0
    top: 50%
    margin: -3px 0 0 0
    right: 8px
    position: absolute
    pointer-events: none
  select
    border: 0
    border-radius: 4px
    background: #303B50
    color: #fff
    font-size: 16px
    line-height: 16px
    font-weight: 600
    height: 32px
    width: 100%
    padding: 0 0 0 12px
    cursor: pointer
    appearance: none
    -moz-appearance: none
    -webkit-appearance: none
    &::-ms-expand
      display: none
</style>